/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import {  DOCUMENT_LIST } from "../../../repository/document_repo";
import { uploadFile } from "../../../repository/attendanceRepo";
import { personalDoc } from "../../../repository/auth";
import useReduxStore from "../../../hooks/useReduxStore";

const useDocument = () => {

  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [documentList, setDocumentList] = useState([]);
  const [formError, setFormError] = useState({});
  const { agentId } = useParams(); // Get ID from URL params



  const handlePagination = (obj) => {
    setController(obj);
  };

  useEffect(() => {
  
      documentListAPI();

  }, []);



  const documentListAPI = async () => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        userId: agentId,
        isActive: true,
      };

      setSpinner(true);
      let response = await DOCUMENT_LIST(payload);
      setDocumentList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      setDocumentList([]);
    }
    setSpinner(false);
  };



  return {
    data: {
      spinner,
      formError,
      controller,
      totalCount,
      documentList,
      personalDoc,
    },
    methods: {
      handlePagination,
    },
  };
};

export default useDocument;
